import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import DateTime from 'react-datetime';
import * as moment from 'moment';
import AsyncSelect from 'react-select/lib/Async';

class OutreachForm extends React.Component {
  static propTypes = {
    view: PropTypes.string,
    toggleNotes: PropTypes.func,
    onSubmit: PropTypes.func,
    masterPatientId: PropTypes.number,
  };

  renderToggler = props => (
    <label className="checkbox-inline">
      <input type="checkbox" {...props.input} /> {props.label}
    </label>
  );

  renderTextarea = ({
    input,
    label,
    type,
    meta: { touched, error, warning, invalid },
  }) => (
    <div className={`form-group ${touched && invalid ? 'has-error' : ''}`}>
      <label>{label}</label>
      <div>
        <textarea
          {...input}
          rows="5"
          placeholder={label}
          type={type}
          className={`form-control`}
        />
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );

  renderDateField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-3 control-label">{label}</label>
      <div className="col-md-9">
        <DateTime
          // dateFormat="YYYY-MM-DD"
          timeFormat={false}
          viewDate={input.value}
          {...input}
          renderInput={(props, openCalendar, closeCalendar) => {
            const value =
              props.value && moment(props.value)
                ? moment(props.value).format('MM/DD/YYYY')
                : (label === 'date') ? moment().format('MM/DD/YYYY') : null;
            return (
              <div className="input-group">
                <input {...props} type="hidden" />
                <input
                  className="form-control"
                  type="text"
                  value={value}
                  onFocus={openCalendar}
                />
                <span className="input-group-addon" onClick={openCalendar}>
                  <i className="fa fa-calendar" />
                </span>
              </div>
            );
          }}
          renderDay={(props, currentDate, selectedDate) => {
            return <td {...props}>{currentDate.date()}</td>;
          }}
          onChange={param => {
            if (param) {
              // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
              input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
              // input.onChange(param)
            }
          }}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderTypesSelect = ({
    meta: { touched, error, warning },
    label,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          //isMulti
          loadOptions={this.props.searchOutreachTypes}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Outreach Type..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onTypeChange = (val) => {
    this.props.change('outreachType', val);
  }

  onStatusChange = (name, value) => {
    this.props.change(name, !value);
  };

  submit = values => {
    const { onSubmit } = this.props;
    const actionValues = {};
    actionValues.id = values.id;
    actionValues.createdAt = values.createdAt;
    actionValues.createdBy = values.createdBy;
    actionValues.date = values.date;
    actionValues.note = values.note;
    actionValues.outreachType = values.outreachType;
    actionValues.nextFlowUpAt = values.nextFlowUpAt;
    //actionValues.copyToAthena = values.copyToAthena;
    if (this.props.initialValues.masterPatientId) {
      actionValues.masterPatientId = this.props.initialValues.masterPatientId;
    }
    return onSubmit(actionValues);
  };

  render() {
    const {
      toggleNotes,
      handleSubmit,
      pristine,
      submitting,
      isLoading,
      isExecutive,
    } = this.props;

    return (
      <form className="outreach-form" onSubmit={handleSubmit(this.submit)}>
        <fieldset>
          <legend>
            New Outreach
          </legend>
          <div className="row">
            <div className="col-md-5">
              <div className="form-group">
                <Field
                  className="form-control"
                  name="date"
                  component={this.renderDateField}
                  type="text"
                  placeholder="Date"
                  label="Date"
                />
              </div>
            </div>
            <div className="col-md-7">
              <div className="form-group">
                <Field
                  name="outreachType"
                  component={this.renderTypesSelect}
                  label="Outreach Type"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-7">
              <div className="form-group">
                <Field
                  name="note"
                  className="form-control"
                  component={this.renderTextarea}
                  label="Note"
                />
              </div>
            </div>
            <div className="col-md-5">
              <div className="form-group">
                <Field
                  className="form-control"
                  name="nextFlowUpAt"
                  component={this.renderDateField}
                  type="text"
                  placeholder="Follow-Up"
                  label="FOLLOW-UP"
                />
              </div>
            </div>
          </div>
        </fieldset>
        <div className="form-actions">
          <div className="row">
            {/*<div className="col-sm-8">*/}
            {/*  <div className="text-right">*/}
            {/*        <Field*/}
            {/*          name="copyToAthena"*/}
            {/*          className="form-control"*/}
            {/*          component={this.renderToggler}*/}
            {/*          label="Copy to Athena (CASE)"*/}
            {/*          btnClass="btn-default"*/}
            {/*          icon="glyphicon-check"*/}
            {/*        />*/}
            {/*      </div>*/}
            {/*  </div>*/}
            
            <div className="col-sm-12">
              <button
                type="button"
                className="btn btn-default"
                onClick={() => toggleNotes()}
                disabled={submitting}
              >
                Cancel
              </button>
              &nbsp;
              <button
                type="submit"
                className="btn btn-primary"
                disabled={pristine || submitting || isExecutive}
              >
               Save
              </button>
            </div>
          </div>
        </div>
        {isLoading && (
          <div className="cover">
            <div className="spinner inline" />
          </div>
        )}
      </form>
    );
  }
}
const validate = (values, props) => {
  const errors = {};
  
  if (!values.note) {
    errors.note = 'Required';
  }
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: {
      note: '',
      date: moment().format(
        'YYYY-MM-DDThh:mm:ss',
      ),
      masterPatientId: ownProps.masterPatientId,
    },
    validate,
    form: `outreachForm_${ownProps.masterPatientId}`
  };
}
export default compose(
  connect(mapStateToProps),
  reduxForm({
    //other redux-form options...
  })
)(OutreachForm);



// WEBPACK FOOTER //
// ./src/routes/administration/components/OutreachForm.js